import translating from './translate.json';
import { validateForm } from '../../utils';
import { useContext } from 'react';
import GlobalContext from 'contexts';

const organizationForm = translating.organizationForm;

const fields = () => {
  const { sourceList } = useContext(GlobalContext);

  return [
    {
      name: 'name',
      label: organizationForm.name,
      pattern: validateForm('name', translating.name),
      required: true
    },
    {
      name: 'ssn',
      label: organizationForm.tz,
      required: true,
      pattern: validateForm('ssn', organizationForm.tz)
    },
    {
      name: 'phoneNumber',
      required: true,
      label: organizationForm.phone,
      pattern: validateForm('phone', organizationForm.phone)
    },
    {
      name: 'city',
      required: true,
      label: organizationForm.city,
      type: 'address'
    },
    {
      name: 'street',
      label: organizationForm.street,
      type: 'address'
    },
    {
      name: 'buildingNumber',
      required: true,
      label: organizationForm.buildingNumber,
      width: '80px',
      type: 'number'
    },
    {
      name: 'apartmentNumber',
      required: true,
      label: organizationForm.apartmentNumber,
      width: '80px',
      type: 'number'
    },
    {
      name: 'contactName',
      required: true,
      label: organizationForm.contactName,
      pattern: validateForm('name', organizationForm.contactName),
      breakLine: true
    },
    {
      name: 'email',
      required: true,
      label: organizationForm.organizationContactEmail,
      pattern: validateForm('email', organizationForm.email)
    },
    {
      name: 'mobile',
      required: true,
      label: organizationForm.organizationContactMobile,
      pattern: validateForm('mobile', organizationForm.mobile)
    },
    {
      name: 'client_publication_source',
      label: organizationForm.source,
      type: 'select',
      required: true,
      default: 'אורגני',
      options: sourceList,
      breakLine: true
    },
    {
      name: 'isActive',
      label: translating.status,
      type: 'switch',
      default: true
    },
    {
      name: 'tor4uServiceId',
      label: translating.tor4uServiceId,
      required: true
    }
  ];
};

export default fields;
